// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__En7Ej","searchIcon":"SearchInput_searchIcon__Fh9CQ","searchInput":"SearchInput_searchInput__aSJbr"};